import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, getUser, safeInternalPath } from "../api";

export default function InviteLanding() {
  const { token } = useParams();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(false);
  const me = getUser();
  const dest = info?.patient_id ? `/clinica/${info.patient_id}` : "/";
  const revoked = info?.status === "revoked";
  const active = info && !revoked && info.patient_id;

  useEffect(() => {
    api.get(`/invite/${token}`).then(({ data }) => setInfo(data)).catch(() => setErr(true));
  }, [token]);

  useEffect(() => {
    // già loggato come pro/struttura e invito valido -> vai alla cartella clinica
    if (me && me.role !== "user" && active) nav(dest, { replace: true });
  }, [me, info]); // eslint-disable-line

  // Conserva il contesto invito lato browser (backup); la destinazione è comunque
  // ridata dal server al primo login riuscito dell'account approvato.
  const go = (path) => {
    try { localStorage.setItem("yp_invite_token", token); localStorage.setItem("yp_invite_next", safeInternalPath(dest) || ""); } catch {}
    nav(path);
  };
  const q = encodeURIComponent(safeInternalPath(dest) || "/");

  return (<div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
    <div className="bg-white rounded-xl max-w-md w-full p-6 space-y-4 shadow" data-testid="invite-landing">
      <h1 className="text-2xl font-bold">Fascicolo diagnostico condiviso su YouPAM</h1>
      {err && <p className="text-red-600 text-sm" data-testid="invite-error">Invito non valido o non più disponibile.</p>}
      {!err && (<>
        <p className="text-sm text-slate-600" data-testid="invite-status">{revoked ? "Questo invito è stato revocato dal paziente e non è più valido." : "Un paziente desidera condividere con te un fascicolo diagnostico. Accedi o crea un account per consultarlo."}</p>
        {!revoked && (<>
          <button className="yp-btn yp-btn-primary w-full" onClick={() => go(`/login?next=${q}`)} data-testid="invite-login-btn">Accedi</button>
          <div className="text-xs text-slate-500 text-center">Non hai un account? Scegli come registrarti:</div>
          <div className="flex gap-2">
            <button className="yp-btn yp-btn-outline flex-1" onClick={() => go(`/register/pro?invite=${token}&next=${q}`)} data-testid="invite-pro-btn">Sono un Professionista</button>
            <button className="yp-btn yp-btn-outline flex-1" onClick={() => go(`/register/org?invite=${token}&next=${q}`)} data-testid="invite-org-btn">Rappresento una Struttura</button>
          </div>
        </>)}
      </>)}
    </div>
  </div>);
}
